import MojitoCore from 'mojito/core';
import MojitoServices from 'mojito/services';
import MojitoModules from 'mojito/modules';
import MojitoApplications from 'mojito/applications';
import MojitoPresentation from 'mojito/presentation';

import {ensureHierarchy, mergeTo} from '#core/utils/config-utils.js';
import {getParamFromURL, getDeeplink} from '#core/utils/url-utils.js';

import {AbstractFeature, allFeatures} from '#core/application/abstract-feature.js';

import SCHEMA from './affiliate-bet-sharing.schema.yaml';

const {dispatch} = MojitoCore.Services.redux.store;

const {COMMIT_BETSLIP_MODE} = MojitoServices.Betslip.types;
const UserInfoActions = MojitoServices.UserInfo.actions;
const {BETSLIP_TYPE} = MojitoModules.SlidingBetslip.types;
const {ADD_FIRST_SELECTION, CONTAINS_MAX_ACCUMULATOR, CONTAINS_ONE_BET_BUILDER, ADD_MATCH_ACCA} =
    MojitoApplications.Sports.ApplicationTypes.SHOW_BETSLIP_CONDITION;
const ShareDialogUtils = MojitoModules.ShareDialog.utils;
const NavigationPathBuilder = MojitoPresentation.Base.Navigation.NavigationPathBuilder;

const ID_PARAM = 'advertiser';
const MODE_PARAM = 'shareMode';

class affiliateBetSharingFeature extends AbstractFeature {
    constructor(parent) {
        super(parent);

        this.advertiserId = getParamFromURL(ID_PARAM);
        this.isShareMode = getParamFromURL(MODE_PARAM) === 'true';
    }

    get configSchema() {
        return SCHEMA;
    }

    get enabled() {
        return this.config.enabled && !!this.advertiserId && this.isShareMode;
    }

    get name() {
        return 'AffiliateBetSharing';
    }

    updateMojitoConfig(mojitoConfig) {
        const services = ensureHierarchy(mojitoConfig, 'services');
        const application = ensureHierarchy(mojitoConfig, 'application');

        ShareDialogUtils.getDeeplink = (routeResolver, betRefs = []) => {
            return getDeeplink({
                path: routeResolver.getRoute(NavigationPathBuilder.toBetslipDeepLink()),
                betRefs,
                append: {clear_slip: 'Y', source: 'SHARE_BET'},
                exclude: [ID_PARAM, MODE_PARAM],
            });
        };

        mergeTo(services, {
            stores: {
                betslip: {
                    commitBetslipMode: COMMIT_BETSLIP_MODE.SHARE_BET,
                },
            },
        });

        mergeTo(application, {
            stores: {
                application: {
                    betslipAutoShowUp: {
                        [ADD_FIRST_SELECTION]: BETSLIP_TYPE.STANDARD_BETSLIP,
                        [CONTAINS_MAX_ACCUMULATOR]: BETSLIP_TYPE.STANDARD_BETSLIP,
                        ...(GENBET_BASED
                            ? {[CONTAINS_ONE_BET_BUILDER]: BETSLIP_TYPE.STANDARD_BETSLIP}
                            : {[ADD_MATCH_ACCA]: BETSLIP_TYPE.STANDARD_BETSLIP}),
                    },
                },
            },
        });

        super.updateMojitoConfig(mojitoConfig);
    }

    afterMojito() {
        this.logger.info(`Advertiser Id detected: ${this.advertiserId}`);
        dispatch(UserInfoActions.updateUserInfo({affiliate: this.advertiserId}));

        return super.afterMojito();
    }
}

new affiliateBetSharingFeature(allFeatures);
